/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    name: 'login',
    path: '/login',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    name: 'logout',
    path: '/logout',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/reset-pass',
    component: import('@/views/auth/ResetPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/create-pass',
    component: import('@/views/auth/CreatePass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/confirm-reset-pass',
    component: import('@/views/auth/ConfirmResetPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: import('@/views/Dashboard.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/country',
    name: 'Country',
    component: import('@/views/country/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/site',
    name: 'Sites',
    component: import('@/views/site/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/account',
    name: 'Accounts',
    component: import('@/views/account/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol',
    name: 'Protocols',
    component: import('@/views/protocol/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol_details/:id',
    name: 'Protocol details',
    component: import('@/views/protocol_details/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol/new',
    name: 'New Protocol',
    component: import('@/views/protocol/New.vue'),
    meta: { layout: 'default' }
  },



  {
    path: '/protocol_roles',
    name: 'Protocol Roles',
    component: import('@/views/protocol_roles/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol_roles/:protocolId',
    name: 'Protocol Roles Details',
    component: import('@/views/protocol_roles/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol_roles/:id',
    name: 'Protocol Roles details',
    component: import('@/views/protocol_roles/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol_roles/:protocolId/new',
    name: 'New Protocol Role',
    component: import('@/views/protocol_roles/New.vue'),
    meta: { layout: 'default' }
  },


  
  {
    path: '/protocol/:id',
    name: 'Edit Protocol',
    component: import('@/views/protocol/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/user',
    name: 'Users',
    component: import('@/views/user/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/user/new',
    name: 'New User',
    component: import('@/views/user/New.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/user/:id',
    name: 'Edit User',
    component: import('@/views/user/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/new_user/:uuid',
    name: 'New User public',
    component: import('@/views/user/NewPublic.vue'),
    meta: { layout: 'no-sidebar' }
  },

  // {
  //   path: '/protocol/:id',
  //   name: 'Edit Protocol',
  //   component: import('@/views/protocol/Edit.vue'),
  //   meta: { layout: 'default' }
  // },
  // {
  //   path: '/protocol/:protocolId/sites',
  //   name: 'Protocol Sites',
  //   component: import('@/views/protocol_has_site/Index.vue'),
  //   meta: { layout: 'default' }
  // },
  {
    path: '/protocol_has_site',
    name: 'Protocol Sites',
    component: import('@/views/protocol_has_site/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/meddra',
    name: 'MedDRA',
    component: import('@/views/meddra/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/smtp',
    name: 'Smtp',
    component: import('@/views/smtp/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/email',
    name: 'Email',
    component: import('@/views/email/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/redcap_deploy',
    name: 'REDCap Deploy',
    component: import('@/views/deploy/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: import('@/views/maintenance/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/customer',
    name: 'Customer',
    component: import('@/views/customer/Index.vue'),
    meta: { layout: 'default' }
  }
]
